import types from './types'
import axios from 'axios'

export default {
  namespaced: true,
  state: {
    status: void 0,
    questionnaire: {},
    questionnaireObj: {},
    items: [],
    total: 0
  },
  actions: {
    async getList ({ commit }, { questionnaireId, page = 1, perPage = 10, sf, so, months }){
      commit(types.GET_TEAMS.REQUEST, { questionnaireId, page, perPage, sf, so })
      try {
        commit(types.GET_TEAMS.SUCCESS, await axios.get(`/api/waveline/questionnaires/${questionnaireId}`, { params: { l: perPage, lo: page - 1, sf, so, months } }))
      } catch (err) {
        commit(types.GET_TEAMS.FAILURE)
      } finally {
      }
    }
  },
  mutations: {
    [types.GET_TEAMS.REQUEST] (state, params) {
      state.status = 'fetching'
      if ( state.questionnaire !== params.questionnaireId){
        state.items = []
      }
      state.questionnaire = params.questionnaireId
    },
    [types.GET_TEAMS.SUCCESS] (state, result) {
      state.status = 'success'
      state.items = result.data.items
      state.total = result.data.total
      state.questionnaireObj = result.data.questionnaire
    },
    [types.GET_TEAMS.FAILURE] (state) {
      state.status = 'error'
    }
  },
  getters: {
    getTeams: state => questionnaireId => {
      if ( state.questionnaire === questionnaireId ){
        return state.items
      }
      return null
    }
  }
}
